import { createStyles, makeStyles } from '@hawkins/styles';
export var VERTICAL_NAV_COLLAPSED_WIDTH = 80;
export function verticalNavigationStyles(theme) {
    var hawkins = theme.hawkins, hawkinsVariables = theme.hawkinsVariables;
    return createStyles({
        /** Class name of the element containing the component’s children.  */
        childrenContainer: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            gap: hawkinsVariables.spacings.space3,
        },
        /** Class name of the divider between the collapse control and the quick actions.  */
        collapseControlDivider: {
            flexShrink: 0,
        },
        /** Class name of the footer element, which contains the user controls.  */
        footer: {
            // HACK(style): CSS override specificity.
            '&.Hawkins-SidebarFooter': { padding: 0 },
        },
        /** Class name of the header element, which contains the application logo and name.  */
        header: {
            // HACK(style): CSS override specificity.
            '&.Hawkins-SidebarHeader': { padding: "".concat(hawkinsVariables.spacings.space4, " ").concat(hawkinsVariables.spacings.space5) },
        },
        /** Class name of the header element in tier 1 when the component is tiered.  */
        headerPersistent: {
            // HACK: The `SidebarHeader` inside tier 1 gets a `hasScroll` CSS class applied to it when tier 2 is collapsed
            // (even though it's not actually scrolling), so disable the elevation styling.
            //
            // TODO(style): Fix the root cause.
            border: 0,
            boxShadow: 'none',
        },
        /** Class name of the main content container element.  */
        mainContent: {
            // HACK(style): CSS override specificity.
            '&.Hawkins-SidebarContent': { padding: 0 },
        },
        /** Class name of the main content container when the collapse control is sticky.  */
        mainContentStickyCollapseControl: {
            position: 'relative',
        },
        /** Class name of the root element. */
        root: {
            boxShadow: hawkins.elevation.boxShadow2,
            // HACK(style): CSS override specificity.
            '&.Hawkins-Sidebar': { backgroundColor: hawkins.elevation.backgroundColor2 },
        },
        /** Class name of the root element when the component is collapsed. */
        rootCollapsed: {
            // HACK(style): CSS override specificity.
            '&.Hawkins-Sidebar': { width: VERTICAL_NAV_COLLAPSED_WIDTH },
        },
        /** Class name of the root element when the component is tiered. */
        rootTiered: {
            boxShadow: hawkins.elevation.boxShadow1,
            // HACK(style): CSS override specificity.
            '&.Hawkins-Sidebar': { backgroundColor: hawkins.elevation.backgroundColor1 },
        },
        /** Class name of the tier 1 element. */
        tier1: {
            flexShrink: 0,
            // HACK(style): CSS override specificity.
            '&.Hawkins-SidebarPersistentControls': { width: VERTICAL_NAV_COLLAPSED_WIDTH },
        },
        /** Class name of the tier 2 element. */
        tier2: {
            // HACK(style): CSS override specificity.
            '&.Hawkins-SidebarContent': { padding: 0 },
        },
    });
}
export var useVerticalNavigationStyles = makeStyles(verticalNavigationStyles, { name: 'Hawkins-VerticalNavigation' });
